/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
} from './PalAuthPlatformPayorForm';
import type { PalAuthSubmissionGeneratedDocument } from './PalAuthSubmissionGeneratedDocument';
import {
    PalAuthSubmissionGeneratedDocumentFromJSON,
    PalAuthSubmissionGeneratedDocumentFromJSONTyped,
    PalAuthSubmissionGeneratedDocumentToJSON,
} from './PalAuthSubmissionGeneratedDocument';
import type { PalAuthSubmissionLead } from './PalAuthSubmissionLead';
import {
    PalAuthSubmissionLeadFromJSON,
    PalAuthSubmissionLeadFromJSONTyped,
    PalAuthSubmissionLeadToJSON,
} from './PalAuthSubmissionLead';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
} from './PalAuthSubmissionStatus';
import type { PalAuthSubmissionStatusInfo } from './PalAuthSubmissionStatusInfo';
import {
    PalAuthSubmissionStatusInfoFromJSON,
    PalAuthSubmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionStatusInfoToJSON,
} from './PalAuthSubmissionStatusInfo';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalSubmissionListEntryTimExecution } from './PalSubmissionListEntryTimExecution';
import {
    PalSubmissionListEntryTimExecutionFromJSON,
    PalSubmissionListEntryTimExecutionFromJSONTyped,
    PalSubmissionListEntryTimExecutionToJSON,
} from './PalSubmissionListEntryTimExecution';

/**
 * 
 * @export
 * @interface PalSubmissionListEntry
 */
export interface PalSubmissionListEntry {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntry
     */
    lead_id: string;
    /**
     * 
     * @type {PalAuthSubmissionStatus}
     * @memberof PalSubmissionListEntry
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntry
     */
    status_updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntry
     */
    external_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalSubmissionListEntry
     */
    is_non_submission_flow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalSubmissionListEntry
     */
    is_oon?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalSubmissionListEntry
     */
    can_revert_status?: boolean;
    /**
     * 
     * @type {PalAuthSubmissionLead}
     * @memberof PalSubmissionListEntry
     */
    lead?: PalAuthSubmissionLead;
    /**
     * 
     * @type {boolean}
     * @memberof PalSubmissionListEntry
     */
    should_sync_remote_status?: boolean;
    /**
     * 
     * @type {PalSubmissionListEntryTimExecution}
     * @memberof PalSubmissionListEntry
     */
    tim_execution?: PalSubmissionListEntryTimExecution;
    /**
     * 
     * @type {PalAuthPlatformPayorForm}
     * @memberof PalSubmissionListEntry
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * 
     * @type {PalAuthSubmissionStatusInfo}
     * @memberof PalSubmissionListEntry
     */
    status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     * @type {PalAuthSubmissionStatusInfo}
     * @memberof PalSubmissionListEntry
     */
    previous_status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUser}
     * @memberof PalSubmissionListEntry
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     * @type {PalAuthSubmissionGeneratedDocument}
     * @memberof PalSubmissionListEntry
     */
    generated_document?: PalAuthSubmissionGeneratedDocument;
}

/**
 * Check if a given object implements the PalSubmissionListEntry interface.
 */
export function instanceOfPalSubmissionListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PalSubmissionListEntryFromJSON(json: any): PalSubmissionListEntry {
    return PalSubmissionListEntryFromJSONTyped(json, false);
}

export function PalSubmissionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'status_updated_at': !exists(json, 'status_updated_at') ? undefined : json['status_updated_at'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
        'is_oon': !exists(json, 'is_oon') ? undefined : json['is_oon'],
        'can_revert_status': !exists(json, 'can_revert_status') ? undefined : json['can_revert_status'],
        'lead': !exists(json, 'lead') ? undefined : PalAuthSubmissionLeadFromJSON(json['lead']),
        'should_sync_remote_status': !exists(json, 'should_sync_remote_status') ? undefined : json['should_sync_remote_status'],
        'tim_execution': !exists(json, 'tim_execution') ? undefined : PalSubmissionListEntryTimExecutionFromJSON(json['tim_execution']),
        'auth_platform_form': !exists(json, 'auth_platform_form') ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'status_info': !exists(json, 'status_info') ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': !exists(json, 'previous_status_info') ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'status_updated_by_user': !exists(json, 'status_updated_by_user') ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'generated_document': !exists(json, 'generated_document') ? undefined : PalAuthSubmissionGeneratedDocumentFromJSON(json['generated_document']),
    };
}

export function PalSubmissionListEntryToJSON(value?: PalSubmissionListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': PalAuthSubmissionStatusToJSON(value.status),
        'status_updated_at': value.status_updated_at,
        'external_id': value.external_id,
        'is_non_submission_flow': value.is_non_submission_flow,
        'is_oon': value.is_oon,
        'can_revert_status': value.can_revert_status,
        'lead': PalAuthSubmissionLeadToJSON(value.lead),
        'should_sync_remote_status': value.should_sync_remote_status,
        'tim_execution': PalSubmissionListEntryTimExecutionToJSON(value.tim_execution),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value.auth_platform_form),
        'status_info': PalAuthSubmissionStatusInfoToJSON(value.status_info),
        'previous_status_info': PalAuthSubmissionStatusInfoToJSON(value.previous_status_info),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value.status_updated_by_user),
        'generated_document': PalAuthSubmissionGeneratedDocumentToJSON(value.generated_document),
    };
}

